import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import api from '../api/axios';
import Layout from '../components/Layout';

const Dashboard = () => {
  const [stats, setStats] = useState({ total: 0, active: 0 });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      const response = await api.get('/drivers/stats');
      setStats(response.data);
    } catch (error) {
      console.error('Error loading stats:', error);
    }
  };

  return (
    <Layout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold text-nexolog-navy">לוח בקרה</h1>

        {/* Stats Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-sm font-medium text-gray-500">נהגים פעילים</h3>
            <p className="text-3xl font-bold text-nexolog-teal mt-2">{stats.active}</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-sm font-medium text-gray-500">סה"כ נהגים</h3>
            <p className="text-3xl font-bold text-nexolog-navy mt-2">{stats.total}</p>
          </div>
          <div className="bg-white rounded-lg shadow p-6">
            <h3 className="text-sm font-medium text-gray-500">חודש נוכחי</h3>
            <p className="text-3xl font-bold text-gray-800 mt-2">{new Date().toLocaleDateString('he-IL', { month: 'long', year: 'numeric' })}</p>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="bg-white rounded-lg shadow p-6">
          <h2 className="text-xl font-bold text-nexolog-navy mb-4">פעולות מהירות</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <Link
              to="/drivers"
              className="bg-green-500 hover:bg-green-600 text-white font-medium py-4 px-6 rounded-lg text-center transition-colors"
            >
              + הוסף נהג חדש
            </Link>
            <Link
              to="/uploads"
              className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-4 px-6 rounded-lg text-center transition-colors"
            >
              העלה קובץ
            </Link>
            <Link
              to="/reports"
              className="bg-purple-500 hover:bg-purple-600 text-white font-medium py-4 px-6 rounded-lg text-center transition-colors"
            >
              צפה בדוחות
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Dashboard;

